import jwt_decode from "jwt-decode";

const saveAuthTokens = (accessToken, idToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("idToken", idToken);
};

const clearAuthTokens = () => {
  localStorage.removeItem("idToken");
  localStorage.removeItem("accessToken");
};

const retrieveAuthTokens = () => {
  let accessToken;
  let idToken;
  const urlHash = window.location.hash;
  if (urlHash.includes("access_token") && urlHash.includes("id_token")) {
    try {
      accessToken = urlHash.match(/(?:access_token)=([\S\s]*?)&/)[1];
      idToken = urlHash.match(/(?:id_token)=([\S\s]*?)&/)[1];
    } catch (error) {
      console.log("error retrieving tokens from url");
    }
  } else {
    idToken = localStorage.getItem("idToken");
    accessToken = localStorage.getItem("accessToken");
  }

  return { accessToken, idToken };
};

const parseAuthTokens = (accessToken, idToken) => {
  if (!accessToken && !idToken) {
    return {};
  }

  let decodedAccessToken;
  let decodedIdToken;

  try {
    decodedAccessToken = jwt_decode(accessToken);
    decodedIdToken = jwt_decode(idToken);
  } catch (error) {
    console.log("Tokens were most likely malformed. Error message: ", error);
    return {};
  }

  const nowSeconds = Date.now() / 1000;
  if (
    decodedAccessToken.exp &&
    decodedAccessToken.exp > nowSeconds &&
    decodedIdToken.exp &&
    decodedIdToken.exp > nowSeconds
  ) {
    return { decodedAccessToken, decodedIdToken };
  } else {
    console.log("id and/or access token has expired.");

    return {};
  }
};

export { saveAuthTokens, clearAuthTokens, retrieveAuthTokens, parseAuthTokens };
